import { AUTH_KEY, REF_CODE, TOKEN_KEY } from '~/constants/storage'

export function isAdmin() {
  const auth = localStorage.getItem(AUTH_KEY)
  return auth === 'ADMIN'
}

export function logoutStorage() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(AUTH_KEY)
  localStorage.removeItem(REF_CODE)
}
